module.exports = __webpack_public_path__ + "static/illustration-4-ab573a89d5499a0bceb0aa2252631a08.svg";